export default "__VITE_PUBLIC_ASSET__8348ac7f__"